import React from "react";
import PaginaToolbar from "../components/PaginaToolbar";
import {
  DataGrid,
  FilterRow,
  Editing,
  Column,
  Paging,
  Pager,
} from "devextreme-react/data-grid";
import memoria from "../Memoria";
import UserInfo from "../UserInfo.js";
import apiAxios from "../api-axios";
import uiInfo from "../ui-info";
import Button from "devextreme-react/button";
import notify from "devextreme/ui/notify";
import showError from "../AppServices";
import { Popup } from "devextreme-react/popup";

export default class PreMigracaoCpbsBox extends React.Component {
  constructor(props) {
    super(props);
    this._gridInstance = React.createRef();
    this.onSelecionado = props.onSelecionado;
    this.usadoComoPesquisa = props.onSelecionado !== undefined;
    this.buscarNovasInfos = this.buscarNovasInfos.bind(this);
    this.salvarSequenciaisDestino = this.salvarSequenciaisDestino.bind(this);
    this.executarMigracao = this.executarMigracao.bind(this);
    this.importarCnaes = this.importarCnaes.bind(this);
    this.buscarMigracoes = this.buscarMigracoes.bind(this);

    this.state = { gridDs: [], popupConfirmacao: false };
  }

  async componentDidMount() {
    memoria.redirecionarSeNecessario(this.props.location, this.props.history);

    const response = await apiAxios.get(
      "/cpbs/buscar_transicoes/" + UserInfo.getPrefeitura()
    );

    this.setState({ ...this.state, gridDs: response.data });
  }

  async buscarNovasInfos() {
    const response = await apiAxios.get(
      "/cpbs/transicao_cpbs/" + UserInfo.getPrefeitura()
    );

    this.setState({ ...this.state, gridDs: response.data });
  }

  salvarSequenciaisDestino() {
    apiAxios
      .post(
        "/cpbs/transicao_cpbs/" + UserInfo.getPrefeitura(),
        this._gridInstance.instance.getDataSource()._items
      )
      .then(() => {
        notify("Sequenciais salvos com sucesso!", "success");
      })
      .catch((error) => {
        showError(error);
      });
  }

  async executarMigracao() {
    const response = await apiAxios.get(
      "/cpbs/executar_migracao/" + UserInfo.getPrefeitura()
    );

    if(response.status === 200) notify("Migração executada com sucesso!", "success");
    else notify("Erro ao executar migração!", "error");

    this.setState({ ...this.state, gridDs: response.data });
  }

  importarCnaes() {
    apiAxios
      .post("/cpbs/importar_cnaes_nfse/" + UserInfo.getPrefeitura())
      .then(() => {
        notify("Importação realizada com sucesso!", "success");
      })
      .catch((error) => {
        showError(error);
      });

      this.setState({...this.state, popupConfirmacao: false})
  }

  async buscarMigracoes() {
    const response = await apiAxios.get(
      "/cpbs/transicao_cpbs/" + UserInfo.getPrefeitura()
    );

    this.setState({ ...this.state, gridDs: response.data });
  }

  render() {
    return (
      <React.Fragment>
        <div className={"content-block dx-card responsive-paddings"}>
          <form>
            <div style={{ marginTop: "20px" }}>
              <div style={{ display: "inline-block" }}>
                <Button
                  text="Buscar Novas Informações NFSe"
                  type="success"
                  onClick={this.buscarNovasInfos}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button
                  text="Salvar Sequenciais Destino"
                  onClick={this.salvarSequenciaisDestino}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button
                  text="Executar Migração"
                  onClick={this.executarMigracao}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button
                  text="Importar Cnaes da NFSe"
                  onClick={() => this.setState({ popupConfirmacao: true })}
                />
              </div>
            </div>
          </form>
          <br />
          <br />
          <br />
          <form>
          <div style={{ display: "inline-block", marginLeft: "10px" }}>
              <Button
                text="Buscar Migrações"
                onClick={this.buscarMigracoes}
              />
            </div>
          </form>
          <PaginaToolbar titulo="Pré-Migração CPBS NFSe" ocultarNovo={true}>
            
            <DataGrid
              ref={(grid) => (this._gridInstance = grid)}
              dataSource={this.state.gridDs}
              showBorders={true}
              rowAlternationEnabled={true}
              remoteOperations={true}
              columnAutoWidth={true}
              columnHidingEnabled={true}
              wordWrapEnabled={window.innerWidth < 800}
              filterSyncEnabled={true}
            >
              <FilterRow visible={true} />
              <Editing
                allowDeleting={!this.usadoComoPesquisa}
                allowUpdating={true}
                useIcons={true}
                visible={!this.usadoComoPesquisa}
              />
              <Column
                type="buttons"
                fixed={true}
                fixedPosition={"left"}
                buttons={["edit", "delete"]}
              />
              <Column
                dataField={"codigoNfse"}
                caption={"Cód. Cpbs NFSe"}
                alignment={"left"}
                sortIndex={1}
                width={"200"}
                allowEditing={false}
              />
              <Column
                dataField={"inscricao"}
                caption={"Inscrição NFSe"}
                allowEditing={false}
              />
              <Column dataField={"nome"} allowEditing={false} />
              <Column
                dataField={"cpfCnpj "}
                caption={"Documento"}
                allowEditing={false}
              />
              <Column
                dataField={"sequenciaisSgtweb"}
                caption={"Cadastros Encontrados"}
                allowEditing={false}
                alignment={"left"}
              />
              <Column
                dataField={"sequencialDestino"}
                caption={"Cadastro Destino"}
                alignment={"left"}
              />
              <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
              <Pager
                showInfo={true}
                showNavigationButtons={true}
                showPageSizeSelector={true}
                allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
              />
            </DataGrid>
          </PaginaToolbar>

          <Popup
            visible={this.state.popupConfirmacao}
            onHiding={() => this.setState({ popupConfirmacao: false })}
            dragEnabled={false}
            closeOnOutsideClick={true}
            showTitle={true}
            width={"400px"}
            height={"200px"}
            title="Confirmar Importação"
          >
            Todos os CNAEs serão importados para a prefeitura atual. Deseja
            realmente continuar?
            <br></br>
            <div style={{ marginTop: "20px" }} align="center">
              <div style={{ display: "inline-block" }}>
                <Button
                  text="Não"
                  onClick={() => this.setState({ popupConfirmacao: false })}
                />
              </div>
              <div style={{ display: "inline-block", marginLeft: "10px" }}>
                <Button
                  text="Sim"
                  type="success"
                  onClick={this.importarCnaes}
                />
              </div>
            </div>
          </Popup>
        </div>
      </React.Fragment>
    );
  }
}
